<form [formGroup]="formGroup" appPropagateSubmit [parentFormGroupDirective]="parentFormGroupDirective" appSubmitScrollInvalidControl>
  <app-fertigstellen [parentFormGroupDirective]="parentFormGroupDirective" [formGroup]="fertigstellen" [selectedFiles]="selectedFiles"></app-fertigstellen>
  <ng-container *ngIf="showBmNachweis">
    <app-file-upload [parentFormGroupDirective]="parentFormGroupDirective" [dokumentArt]="dokumentArten.BmNachweis" [selectedFilesTotal]="selectedFiles"></app-file-upload>
  </ng-container>
  <ng-container *ngIf="showKaskobesichtigung">
    <app-file-upload [parentFormGroupDirective]="parentFormGroupDirective" [dokumentArt]="dokumentArten.Kaskobesichtigung" [selectedFilesTotal]="selectedFiles"></app-file-upload>
  </ng-container>
  <ng-container *ngIf="showAufstellungSonderausstattung">
    <app-file-upload [parentFormGroupDirective]="parentFormGroupDirective" [dokumentArt]="dokumentArten.Sonderausstattung" [selectedFilesTotal]="selectedFiles"></app-file-upload>
  </ng-container>
  <app-file-upload [parentFormGroupDirective]="parentFormGroupDirective" [dokumentArt]="dokumentArten.Sonstige" [selectedFilesTotal]="selectedFiles"></app-file-upload>
  <div class="row">
    <div class="col col-xs-12 col-sm-12">
      <app-textarea #_anmerkungen [parentFormGroupDirective]="parentFormGroupDirective" [control]="anmerkungen" id="anmerkungen" label="Anmerkung zum Dokumentenupload" [maxCharCount]="1000"></app-textarea>
    </div>
  </div>
  <div class="row">
    <div class="col col-xs-12 col-sm-12 text-right">
      <div class="input_checkbox">
        <mat-checkbox formControlName="kopieAnMich">Kopie per E-Mail an mich senden</mat-checkbox>
      </div>
    </div>
  </div>
</form>
